(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["an-signature-cart"] && !Shopify.designMode) return;
  try {
    
function initAnatoloCart(scope = document) {
  const roots = scope.matches?.('[data-an-cart]') ? [scope] : scope.querySelectorAll('[data-an-cart]');
  roots.forEach(root => {
    if (root.dataset.cartReady) return;
    root.dataset.cartReady = 'true';
    const form = root.querySelector('[data-cart-form]');
    if (!form) return;
    const update = root.querySelector('[data-cart-update]');
    if (update) update.hidden = true;
    let busy = false;
    const sectionId = root.dataset.sectionId;
    const showError = message => {
      const error = root.querySelector('[data-cart-error]');
      error.querySelector('span').textContent = message || root.dataset.error;
      error.hidden = false;
    };
    const replaceCart = (html, count, focus) => {
      if (!html) return null;
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const next = parsed.querySelector('[data-an-cart]');
      if (!next) return null;
      root.replaceWith(next);
      initAnatoloCart(next);
      if (typeof count === 'number') document.querySelectorAll('[data-v3-cart-count]').forEach(el => { el.textContent = String(count); });
      let target;
      if (focus?.key) {
        const item = [...next.querySelectorAll('[data-cart-item]')].find(el => el.dataset.key === focus.key);
        if (item) target = focus.step ? item.querySelector('[data-cart-step="' + focus.step + '"]') : item.querySelector('[data-cart-quantity]');
      }
      if (!target || target.disabled) target = next.querySelector('[data-cart-heading]');
      target?.focus({ preventScroll: true });
      return next;
    };
    const mutate = async (item, quantity, focus) => {
      if (busy) return;
      const input = item.querySelector('[data-cart-quantity]');
      if (!Number.isInteger(quantity) || quantity < 0 || (quantity > 0 && !input.checkValidity())) {
        input.reportValidity();
        return;
      }
      busy = true;
      root.setAttribute('aria-busy', 'true');
      root.querySelector('[data-cart-error]').hidden = true;
      root.querySelector('[data-cart-status]').textContent = root.dataset.updating;
      root.querySelectorAll('button,input').forEach(el => { el.dataset.wasDisabled = String(el.disabled); el.disabled = true; });
      try {
        const response = await fetch(root.dataset.changeUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: item.dataset.key, quantity, sections: [sectionId], sections_url: location.pathname })
        });
        const cart = await response.json();
        if (!response.ok) {
          const description = typeof cart.description === 'string' ? cart.description : root.dataset.error;
          throw new Error(description);
        }
        const next = replaceCart(cart.sections?.[sectionId], cart.item_count, focus);
        if (!next) { location.reload(); return; }
        next.querySelector('[data-cart-status]').textContent = next.dataset.updated;
      } catch (error) {
        try {
          const url = new URL(root.dataset.cartUrl, location.origin);
          url.searchParams.set('section_id', sectionId);
          const refreshed = await fetch(url, { headers: { Accept: 'text/html' } });
          const next = refreshed.ok ? replaceCart(await refreshed.text(), undefined, focus) : null;
          if (next) {
            const message = next.querySelector('[data-cart-error]');
            message.querySelector('span').textContent = error.message || next.dataset.error;
            message.hidden = false;
            const count = Number(next.querySelector('[data-cart-heading]>span')?.textContent);
            if (Number.isFinite(count)) document.querySelectorAll('[data-v3-cart-count]').forEach(el => { el.textContent = String(count); });
            return;
          }
        } catch {}
        input.value = input.dataset.previous;
        showError(root.dataset.error);
      } finally {
        busy = false;
        if (root.isConnected) {
          root.removeAttribute('aria-busy');
          root.querySelectorAll('[data-was-disabled]').forEach(el => { el.disabled = el.dataset.wasDisabled === 'true'; delete el.dataset.wasDisabled; });
          root.querySelector('[data-cart-status]').textContent = '';
        }
      }
    };
    root.querySelectorAll('[data-cart-step]').forEach(button => button.addEventListener('click', () => {
      if (busy) return;
      const item = button.closest('[data-cart-item]');
      const input = item.querySelector('[data-cart-quantity]');
      const min = Number(input.min) || 1, max = Number(input.max) || Infinity, step = Number(input.step) || 1;
      const quantity = Math.min(max, Math.max(min, Number(input.value) + Number(button.dataset.cartStep) * step));
      if (quantity === Number(input.value)) return;
      input.value = String(quantity);
      mutate(item, quantity, { key: item.dataset.key, step: button.dataset.cartStep });
    }));
    root.querySelectorAll('[data-cart-quantity]').forEach(input => input.addEventListener('change', () => {
      const item = input.closest('[data-cart-item]');
      mutate(item, Number(input.value), { key: item.dataset.key });
    }));
    root.querySelectorAll('[data-cart-remove]').forEach(link => link.addEventListener('click', event => {
      event.preventDefault();
      mutate(link.closest('[data-cart-item]'), 0);
    }));
    form.addEventListener('submit', event => {
      if (busy) { event.preventDefault(); return; }
      if (event.submitter?.name !== 'checkout') {
        const changed = [...root.querySelectorAll('[data-cart-quantity]')].find(input => input.value !== input.dataset.previous);
        if (changed) {
          event.preventDefault();
          const item = changed.closest('[data-cart-item]');
          mutate(item, Number(changed.value), { key: item.dataset.key });
        }
      }
    });
  });
}
initAnatoloCart();
document.addEventListener('shopify:section:load', event => initAnatoloCart(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
